import { render, staticRenderFns } from "./date-range-type-editor.vue?vue&type=template&id=574545a5&scoped=true&"
import script from "./date-range-type-editor.vue?vue&type=script&lang=js&"
export * from "./date-range-type-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574545a5",
  null
  
)

export default component.exports